export const OPEN_CART_STORE = 'OPEN_CART_STORE'
export const CLOSE_CART_STORE = 'CLOSE_CART_STORE'
/**
 * guarda el pathname en donde se dispara el click de agregar un item al carrito,
 * ejm la home -> /empresas
 */
export const UPDATE_ORIGIN_CLICK_ADD_TO_CART = 'UPDATE_ORIGIN_CLICK_ADD_TO_CART'

export interface ModalCartState {
  open: boolean
  pathToClickAddToCart: string | null
}

export const InitialState: ModalCartState = {
  open: false,
  pathToClickAddToCart: null,
}

export interface OpenCart {
  type: typeof OPEN_CART_STORE
  payload: null
}

export interface CloseCart {
  type: typeof CLOSE_CART_STORE
  payload: null
}

export interface UpdateOriginClickAddToCart {
  type: typeof UPDATE_ORIGIN_CLICK_ADD_TO_CART
  payload: string | null
}

export type ModalCartActions = OpenCart | CloseCart | UpdateOriginClickAddToCart
